// extracted by mini-css-extract-plugin
export default {"title":"filesDownload_title__GrF42","body":"filesDownload_body__711GP","fileItem":"filesDownload_fileItem__DH470"};